export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";